import {put, take, takeLatest} from 'redux-saga/effects'

import * as checkoutActions from '../../actions/checkout'
import * as eventActions from '../../actions/events'

import {checkoutApiError, SAVE_PARTNER} from '../../checkoutErrorCodes'

/**
 * Pass partner info to the event state API. All failures to save are assumed
 * to be server errors here in order to trigger the right checkout error modal.
 */
export function* savePartnerInfoWorker({payload}) {
  yield put(eventActions.updatePartnerInfo(payload))
  const {type} = yield take([
    eventActions.UPDATE_PARTNER_INFO_SUCCESS,
    eventActions.UPDATE_PARTNER_INFO_FAILURE,
  ])
  if (type === eventActions.UPDATE_PARTNER_INFO_FAILURE) {
    yield put(checkoutActions.savePartnerInfoFailure(checkoutApiError(SAVE_PARTNER, 500)))
  } else {
    yield put(checkoutActions.savePartnerInfoSuccess())
  }
}

export function* savePartnerInfoSaga() {
  yield takeLatest(checkoutActions.SAVE_PARTNER_INFO, savePartnerInfoWorker)
}
